const getEnv = (key: string): string | undefined => {
  const value = import.meta.env[key as keyof ImportMetaEnv];
  return typeof value === 'string' && value !== '' ? value : undefined;
};

export const env = {
  API_BASE_URL:
    getEnv('PRODUCT_DEMO_API_BASE_URL') ?? getEnv('VITE_API_BASE_URL') ?? '',
  DEV: Boolean(import.meta.env.DEV),
};

export { getEnv };
